import { render, staticRenderFns } from "./AboutCard.vue?vue&type=template&id=9f44ade4&scoped=true"
import script from "./AboutCard.vue?vue&type=script&lang=ts"
export * from "./AboutCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f44ade4",
  null
  
)

export default component.exports